export const Categories = [
  { value: "MUSIC_EVENT", label: "Music Event" },
  { value: "SPORT_EVENT", label: "Sport Event" },
  { value: "CULTURAL_EVENT", label: "Cultural Event" },
  { value: "ART_EVENT", label: "Art Event" },
  { value: "FOODANDDRINK_EVENT", label: "Food and Drink Event" },
  { value: "FILM_EVENT", label: "Film Event" },
  { value: "COMMUNITYANDCHARITY_EVENT", label: "Community and Charity Event" },
  { value: "RELIGIOUS_EVENT", label: "Religious Event" },
  { value: "ENVIRONMENTAL_EVENT", label: "Environmental Event" },
  { value: "HOILIDAY_EVENT", label: "Holiday Event" },
  { value: "COMEDY_EVENT", label: "Comedy Event" },
];


export const getCategoryLabel = (value) => {
  const category = Categories.find(category => category.value === value);
  return category ? category.label : '';
};




export const getMonthAbbreviation = (dateString, includeYear = false) => {
  if (!dateString) {
    return null;
  }
  const [year, month, day] = dateString.split(/[/-]/);
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthAbbreviation = monthNames[parseInt(month, 10) - 1];
  const formattedDay = day.padStart(2, '0');

  if (includeYear) {
    return { year, day: formattedDay, monthAbbreviation };
  } else {
    return { day: formattedDay, monthAbbreviation };
  }
};